import { useBaseContext } from "context/base"
import Favicon from "react-favicon"

export default function BaseFavicon() {
  const baseContext = useBaseContext()

  return (
    <Favicon url={baseContext?.profile?.logo_minimized || '/favicon.ico'} />
  )
}